export const SOCKET_EVENTS = {
  restaurant: {
    JOIN: 'join:restaurant',
    NEW_ORDER: 'restaurant:new_order',
  },
  client: {
    JOIN: 'join:order',
    STATUS_CHANGED: 'order:status_changed',
    COURIER_LOCATION: 'order:courier_location',
  },
  courier: {
    JOIN: 'join:courier',
    ORDER_ASSIGNED: 'courier:order_assigned',
    ORDER_UNASSIGNED: 'courier:order_unassigned',
    ORDER_STATUS_CHANGED: 'courier:order_status_changed',
  },
}
